import { render, staticRenderFns } from "./PartnerFaqToggleActive.vue?vue&type=template&id=36441d56&scoped=true&"
import script from "./PartnerFaqToggleActive.vue?vue&type=script&lang=ts&"
export * from "./PartnerFaqToggleActive.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerFaqToggleActive.vue?vue&type=style&index=0&id=36441d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36441d56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
